import React, { FunctionComponent } from "react";
import styles from "./Navigation.module.scss";
import NavigationProps from "./NavigationProps.interface";

import Anchor from "components/Anchor/Anchor";

const Navigation: FunctionComponent<NavigationProps> = (props) => {
  return (
    <nav className={styles.wrapper}>
      {props.menu?.map((item: any, index: number) => {
        return (
          <Anchor
            linkType={item.content?._contentType}
            key={index}
            className={styles.link}
            to={item.content.link}
          >
            <span className={styles.link_adjustment}>{item.content.label}</span>
          </Anchor>
        );
      })}
    </nav>
  );
};

export default Navigation;
